module.exports = __webpack_public_path__ + "static/media/seed4.1291478e.jpg";